module.exports = __webpack_public_path__ + "static/media/boek_05.50dcc55d.png";